// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3dSx6","image":"Header_image__29NC9","name":"Header_name__15rG_","info":"Header_info__UcHp2","infoRow":"Header_infoRow__24gF0"};